import axios from 'axios';
import querystring from 'querystring';

let apiUrl = 'https://www.livewelldorset.co.uk/';
if (window.location.href.indexOf('adido.dev') !== -1) {
  apiUrl = 'http://livewelldorset-dev.adidodev.com/';
}
const api = {
  domain: apiUrl,
  ajaxTimer: null,
  ajaxTimerDirect: null,
  token: '',
  handleError: (error, cb) => {
    console.log(`API ERROR: ${error}`);
  },
  gets: [],
  directGets: [],
  sendGet: (endpoint, cb) => {
    api.gets.push({ endpoint, cb });
    if (!api.ajaxTimer) api.ajaxTimer = setTimeout(api.processGet, 10);
  },
  directGet: (endpoint, cb) => {
    api.directGets.push({ endpoint, cb });
    if (!api.ajaxTimerDirect) api.ajaxTimerDirect = setTimeout(api.processDirectGet, 10);
  },
  sendPost: (endpoint, data, cb) => {
    const postArgs = {};
    Object.keys(data).forEach((key) => {
      if (typeof data[key] === 'object') {
        Object.keys(data[key]).forEach((subKey) => {
          if (typeof data[key] === 'object') {
            postArgs[`${key}[${subKey}]`] = data[key][subKey].toString();
          } else {
            postArgs[`${key}[${subKey}]`] = data[key][subKey];
          }
        });
      } else {
        postArgs[key] = data[key];
      }
    });

    const qs = (window.location.search ? querystring.parse(window.location.search.substr(1)) : {});
    if (endpoint === '/json/newclient/' && qs) {
      if (qs.pathway) postArgs['habit[pathway]'] = qs.pathway;
      if (qs.barrier) postArgs['habit[barrier]'] = qs.barrier;
      if (qs.bct) postArgs['habit[bct]'] = qs.bct;
    }

    api
      .proxyPost(endpoint, postArgs)
      .then((response) => {
        // If request is good...
        cb(null, response);
      }).catch(error => api.handleError(error, cb));
  },

  processGet() {
    const { endpoint, cb } = api.gets.pop();
    api
      .proxyGet(endpoint)
      .then((response) => {
        // If request is good...
        cb(null, response);
        if (api.gets.length) {
          api.processGet();
        } else {
          api.ajaxTimer = null;
        }
      }).catch(error => api.handleError(error, cb));
  },
  processDirectGet() {
    const { endpoint, cb } = api.directGets.pop();
    axios
      .get(endpoint)
      .then((response) => {
        // If request is good...
        cb(null, response);
        if (api.directGets.length) {
          api.processDirectGet();
        } else {
          api.ajaxTimerDirect = null;
        }
      }).catch(error => api.handleError(error, cb));
  },
  sendPut(endpoint, data, cb) {
    api
      .proxyPut(endpoint, data)
      .then((response) => {
        // If request is good...
        cb(null, response);
      }).catch(error => api.handleError(error, cb));
  },
  sendDelete(endpoint, cb) {
    api
      .proxyDelete(endpoint)
      .then((response) => {
        // If request is good...
        cb(null, response);
      }).catch(error => api.handleError(error, cb));
  },

  proxyPost(url, data) {
    const token = (url.indexOf('clients/register') === -1 && url !== '/oauth/token' ? api.getToken() : false);
    const sendData = {
      endpoint: url,
      method: 'post',
      post: data,
      token,
    };
    return axios.post('/JSON/proxy/', sendData);
  },

  proxyPut(url, data) {
    const token = api.getToken();
    const sendData = {
      endpoint: url,
      method: 'put',
      post: data,
      token,
    };
    return axios.post('/JSON/proxy/', sendData);
  },
  proxyDelete(url) {
    const token = api.getToken();
    const sendData = {
      endpoint: url,
      method: 'delete',
      token,
    };
    return axios.post('/JSON/proxy/', sendData);
  },

  getToken() {
    const expires = localStorage.getItem('expires_at');
    const token = localStorage.getItem('access_token');
    if (!token || expires <= (new Date().getTime() / 1000)) {
      if (window.location.pathname.indexOf('login') === -1) {
        // window.location = '/login';
      }
    }
    return token;
  },

  proxyGet(url) {
    const token = api.getToken();
    const sendData = {
      endpoint: url,
      method: 'get',
      token,
    };
    return axios.post('/JSON/proxy/', sendData);
  },

  setToken(args) {
    if (!args.access_token) return;
    const expires = (new Date().getTime() / 1000) + args.expires_in;
    localStorage.setItem('access_token', args.access_token);
    localStorage.setItem('expires_at', expires);
    api.token = args.access_token;
  },
  getDropDowns: (params, cb) => {
    api.directGet(`/json/dropdowns.json?${querystring.stringify(params)}`, cb);
  },

  getReferrals: (cb) => {
    api.directGet('/json/dropdowns.json?referral=1', cb);
  },

  getReferral: (id, cb) => {
    api.directGet(`/json/dropdowns.json?referrals=${id}`, cb);
  },
  postRegistration: (data, cb) => {
    const postArgs = {};
    Object.keys(data).forEach((key) => {
      if (typeof data[key] === 'object') {
        Object.keys(data[key]).forEach((subKey) => {
          postArgs[`${key}[${subKey}]`] = data[key][subKey];
        });
      } else {
        postArgs[key] = data[key];
      }
    });

    const qs = (window.location.search ? querystring.parse(window.location.search.substr(1)) : {});
    if (qs.pathway) postArgs['habit[pathway]'] = qs.pathway;
    if (qs.barrier) postArgs['habit[barrier]'] = qs.barrier;
    if (qs.bct) postArgs['habit[bct]'] = qs.bct;

    axios
      .post('/json/newclient/', postArgs)
      .then((response) => {
        console.log(response);
        // If request is good...
        cb(null, response);
      }).catch(error => api.handleError(error, cb));

  },
};

export default api;



// WEBPACK FOOTER //
// ./src/lib/api.js